import React, { FC, useState, useEffect } from 'react';
import { Button, Table, Divider, Modal } from 'antd';
import { PropertyType } from '../../../shared/models/propertyType.enum';
import styles from './FindingTypePropertyTemplate.module.scss';
import { connect } from 'react-redux';
import { RootState } from '../../../rootReducer';
import { AppDispatch } from '../../../store';
import FindingTypePropertyTemplateForm from './FindingTypePropertyTemplateForm';
import {
  fetchFindingTypePropertyTemplates,
  FindingTypePropertyTemplateType,
  saveFindingTypePropertyTemplate,
  showModal,
  deleteFindingTypePropertyTemplate
} from './findingTypePropertyTemplate.slice';
import { deleteOrDeprecate } from '../../../shared/Helpers';

type Props = {
  findingTypePropertyTemplates: Array<FindingTypePropertyTemplateType>;
  loading: boolean;
  onFindingTypePropertyTemplateInit: () => void;
  onFindingTypePropertyTemplateSave: (findingTypePropertyTemplate: FindingTypePropertyTemplateType) => void;
  onShowModal: (visible: boolean) => void;
  onDelete: (id: string) => void;
  modalVisible: boolean;
};

const FindingTypePropertyTemplateTable: FC<Props> = ({
  loading,
  findingTypePropertyTemplates,
  onFindingTypePropertyTemplateInit,
  onShowModal,
  onDelete,
  modalVisible
}) => {
  const [findingTypePropertyTemplateForUpdate, setFindingTypePropertyTemplateForUpdate] = useState<FindingTypePropertyTemplateType>();
  useEffect(() => {
    onFindingTypePropertyTemplateInit();
  }, []);

  function onRowDelete(id: string, method: string) {
    Modal.confirm({
      title: 'Confirm',
      content: `Are you sure you want to ${method} Finding Type Property template?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk: async () => {
        onDelete(id);
      }
    });
  }
  const columns = [
    {
      title: 'Name',
      dataIndex: 'fullName',
      key: 'fullName'
    },
    {
      title: 'Short name',
      dataIndex: 'shortName',
      key: 'shortName'
    },
    {
      title: 'Data type',
      dataIndex: 'type',
      key: 'type',
      render: (typeInt: any) => PropertyType[typeInt]
    },
    {
      title: 'Units',
      key: 'units',
      dataIndex: 'units'
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: any) => (
        <span>
          <a onClick={() => onUpdate(record.id)}>Update</a>
          <Divider type='vertical' />
          <a onClick={() => onRowDelete(record.id, deleteOrDeprecate(record.canDelete))}>{deleteOrDeprecate(record.canDelete)}</a>
        </span>
      )
    }
  ];
  const onAdd = () => {
    const findingTypePropertyTemplateNew: FindingTypePropertyTemplateType = {
      id: '',
      fullName: '',
      description: '',
      shortName: '',
      type: null,
      units: '',
      values: '',
      propertyId: null,
      canDelete: false
    };
    setFindingTypePropertyTemplateForUpdate(findingTypePropertyTemplateNew);
    onShowModal(true);
  };
  const onUpdate = (id: string) => {
    const findingTypePropertyTemplate = findingTypePropertyTemplates.filter(x => x.id === id);
    if (findingTypePropertyTemplate) {
      setFindingTypePropertyTemplateForUpdate(findingTypePropertyTemplate[0]);
      onShowModal(true);
    }
  };
  return (
    <div className={styles.container}>
      <h1 className='mainheader'>Finding Type Property Templates</h1>
      {modalVisible ? <FindingTypePropertyTemplateForm loading={loading} findingTypePropertyTemplate={findingTypePropertyTemplateForUpdate} /> : ''}
      <Button className={styles.button} onClick={() => onAdd()}>
        Add Property
      </Button>
      <Table className='table-without-filters' loading={loading} columns={columns} dataSource={findingTypePropertyTemplates} rowKey='id' />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  findingTypePropertyTemplates: state.findingTypePropertyTemplate.findingTypePropertyTemplates,
  loading: state.findingTypePropertyTemplate.loading,
  modalVisible: state.findingTypePropertyTemplate.modalVisible
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onFindingTypePropertyTemplateInit: () => dispatch(fetchFindingTypePropertyTemplates()),
  onFindingTypePropertyTemplatAdd: (findingTypePropertyTemplate: FindingTypePropertyTemplateType) =>
    dispatch(saveFindingTypePropertyTemplate(findingTypePropertyTemplate)),
  onShowModal: (visible: boolean) => dispatch(showModal(visible)),
  onDelete: (id: string) => dispatch(deleteFindingTypePropertyTemplate(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(FindingTypePropertyTemplateTable);
